import {ThreeEquipment} from '../ThreeEquipment/ThreeEquipment';
import {Vector3} from 'three';
import {SIDE_TYPE_BOTTOM} from '../../../../../../common-code/constants';

export class ThreeBigEquipment extends ThreeEquipment {
    public setPosition(position?: Vector3): void {
        if (position) {
            this.view3d.position.copy(position);
        } else {
            if (this.view3d.position.y !== this.defaultYPosition()) {
                this.view3d.position.y = this.defaultYPosition();
            }
        }
        this.afterSetPosition();
    }

    public defaultYPosition(): number {
        return this.getSideDistance(SIDE_TYPE_BOTTOM);
    }

    protected correctMovePosition(movePosition: Vector3) {
        this.correctFloorUnitMovePosition(movePosition);
    }
}